import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-segment-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segment-stats.component.html',
})
export class SegmentStatsComponent {

  @Input() totalSegmentsCount: number = 0;
  @Input() dynamicSegmentsCount: number = 0;
  @Input() staticSegmentsCount: number = 0;
  @Input() suppressedSegmentsCount: number = 0;

  get cards() {
    return [
      {
        label: 'Listas activas',
        value: this.totalSegmentsCount || 0,
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/></svg>`,
        color: 'text-brand-500',
        bg: 'bg-brand-50 dark:bg-brand-500/10',
      },
      {
        label: 'Dinámicas',
        value: this.dynamicSegmentsCount || 0,
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>`,
        color: 'text-blue-500',
        bg: 'bg-blue-50 dark:bg-blue-500/10',
      },
      {
        label: 'Estáticas',
        value: this.staticSegmentsCount || 0,
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>`,
        color: 'text-success-500',
        bg: 'bg-success-50 dark:bg-success-500/10',
      },
      {
        label: 'Supresión',
        value: this.suppressedSegmentsCount || 0,
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/></svg>`,
        color: 'text-orange-500',
        bg: 'bg-orange-50 dark:bg-orange-500/10',
      },
    ];
  }
}
